
import Vue from "vue";
import {SellCategories} from "@/models/dossier-configs/sell-categories";
import {DossierConfigService, ProductService} from "@/services";
import {Product} from "@/models/base";
import AppPriceCategorySalesDatesEdit from "./PriceCategorySalesDatesEdit.vue";
import AppPriceCategoryDiscountEdit from "./PriceCategoryDiscountEdit.vue";
import {ProductBatchEditSellPricesBodyPrices} from "@/utils/products/product-batch-edit-sell-prices-body-prices";
import AppProductEditSellPriceModalStartingPrice from "./ProductEditSellPricesModalStartingPrice.vue";
import AppProductEditSellPricesModalInterest from "./ProductEditSellPricesModalInterest.vue";

interface IVisibleCategories {
	categoryName: string;
	category: number;
}
export default Vue.extend({
	data(){
		return {
			selectedTab: 0,
			visiblePrices: [] as IVisibleCategories[],
			product: new Product(),
			prices: [] as ProductBatchEditSellPricesBodyPrices[],
			OverwriteAllValues: false
		};
	},
	props: {
		products: {
			type: Array as ()=>Product[],
			required: true
		}
	},
	computed: {
		priceCategories(): SellCategories {
			return DossierConfigService.getSellCategories();
		},
		tabNames(): string[] {
			return this.visiblePrices.map(v => v.categoryName);
		},
		selectedPricateCategory(): number {
			return this.visiblePrices[this.selectedTab].category;
		},
		selectedPrice():ProductBatchEditSellPricesBodyPrices{
			return this.prices[this.selectedPricateCategory];
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(){
			await ProductService.batchEditSellPrices(this.products,this.product.PriceCategorySalesDates,this.OverwriteAllValues,this.prices);
			this.$wf.notify(this.$ct("price-dates-edited"), "success", 3000, "check");
			this.$emit("saved");
			this.close();
		},
		computeVisibleCategories() {
			let cats = this.priceCategories.getCategories();
			this.prices = cats.map(c=>new ProductBatchEditSellPricesBodyPrices());
			this.visiblePrices = cats.map((cat, index) => ({ cat, index }))
				.filter(({ cat }) => cat.Active)
				.map(({ cat, index }) => ({
					categoryName: this.priceCategories.getCategoryName(index + 1),
					category: index
				}));
		}
	},
	created(){
		this.computeVisibleCategories();
	},
	components: {
		AppPriceCategorySalesDatesEdit,
		AppPriceCategoryDiscountEdit,
		AppProductEditSellPriceModalStartingPrice,
		AppProductEditSellPricesModalInterest
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
